import creationStores from "./creationScriptStore";
import home from "./counterStore";
import spaceStroe from "./spaceStore/index";
import login from "./login";
import invite from "./invite";
import team from "./team";
import videoallyis from "./videoallyis";
import teamover from "./teamover";
import userStore from "./userStore";
import YsStore from "./YsStore";
import VideoRes from "./VideoResult";
import configStore from "./mixedConfig";
import appStore from "./appStore";

export default {
  creationStores,
  home,
  ...spaceStroe,
  login,
  team,
  invite,
  teamover,
  videoallyis,
  userStore,
  VideoRes,
  configStore,
  appStore,
  YsStore,
};
